// extracted by mini-css-extract-plugin
export default {"list":"p08_3","item":"_3e3Ib","link":"_1DZSj","icon":"_26ck_","iconWithBackground":"_3zy2X","matchesCount":"_2PGj9","itemSelected":"SgOA1","label":"_1HYpm","caption":"_2IbUl"};